import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signOut 
} from 'firebase/auth';
import { 
  getFirestore, 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  getDocs,
  serverTimestamp,
  Timestamp,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDLH3tpDPM14g1It1L09GnWT0Lm96pDFGY",
  authDomain: "crossdeal-7d789.firebaseapp.com",
  projectId: "crossdeal-7d789",
  storageBucket: "crossdeal-7d789.appspot.com",
  messagingSenderId: "99900570120",
  appId: "1:99900570120:web:3480e999b1a001e4e52fbd",
  measurementId: "G-6E0N3MJ8HX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Export Firestore functions
export { 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  getDocs,
  getCountFromServer,
  limit,
  startAfter,
  serverTimestamp,
  Timestamp,
  onAuthStateChanged,
  signInWithPopup,
  signOut,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
};